import { memo } from "react";
import Paper from "@mui/material/Paper";
import CommentBoxHeader from "./CommentBoxHeader";
import CommentBoxInput from "./CommentBoxInput";
import CommentBoxComments from "./CommentBoxComments";

const CommentBox = () => (
    <Paper
        sx={{
            minWidth: 400
        }}
    >
        <CommentBoxHeader />
        <CommentBoxComments />
        <CommentBoxInput />
    </Paper>
);

export default memo(CommentBox);
